import {connect} from 'react-redux';
import InputText from '../Components/InputText';
import {beautifulGetLabel} from '../Utils/labels';
import {findValue, mapDispatchToProps} from '../Utils/mapToProps';
import {getInDataState} from "../Utils/storeHelpers";

const mapStateToProps = (state, ownProps) => {
    return ({
        ...ownProps,
        label: ownProps.label ?? beautifulGetLabel(ownProps.name),
        value: ownProps.pathInDataState ? getInDataState(ownProps.pathInDataState) : findValue(state)(ownProps),
        defaultValue : getInDataState(ownProps.defaultValue)
    });
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InputText);
